var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4001 17.71C18.4939 17.617 18.5683 17.5064 18.619 17.3846C18.6698 17.2627 18.6959 17.132 18.6959 17C18.6959 16.868 18.6698 16.7373 18.619 16.6154C18.5683 16.4936 18.4939 16.383 18.4001 16.29L13.8101 11.71C13.7164 11.617 13.642 11.5064 13.5912 11.3846C13.5405 11.2627 13.5143 11.132 13.5143 11C13.5143 10.868 13.5405 10.7373 13.5912 10.6154C13.642 10.4936 13.7164 10.383 13.8101 10.29C13.9975 10.1037 14.251 9.99921 14.5151 9.99921C14.7793 9.99921 15.0328 10.1037 15.2201 10.29L19.8101 14.88C20.3719 15.4425 20.6875 16.205 20.6875 17C20.6875 17.795 20.3719 18.5575 19.8101 19.12L15.2201 23.71C15.0339 23.8947 14.7825 23.9989 14.5201 24C14.3885 24.0008 14.2581 23.9755 14.1362 23.9258C14.0144 23.876 13.9036 23.8027 13.8101 23.71C13.7164 23.617 13.642 23.5064 13.5912 23.3846C13.5405 23.2627 13.5143 23.132 13.5143 23C13.5143 22.868 13.5405 22.7373 13.5912 22.6154C13.642 22.4936 13.7164 22.383 13.8101 22.29L18.4001 17.71Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.7076f7ae7ee21c71b80191da1f8caa00.svg";
export { ForwardRef as ReactComponent };